// NucleoInfoCards.jsx
import React from "react";

const NucleoInfoCards = ({ contagens = {}, detalhesConclusao = {}, selectedStatus, onStatusSelect }) => {
  const entries = Object.entries(contagens);

  return (
    <div style={{ maxWidth: 500 }}>
      <div style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gap: "8px",
        alignItems: "start",
      }}>
        {entries.map(([chave, valor]) => {
          if (chave === "Unidades Concluídas") {
            return (
              <CardConclusaoMaster
                key={chave}
                valor={valor}
                detalhes={detalhesConclusao}
              />
            );
          }

          const isTotalCard = chave === "Total Vetorizados";
          const isActive = selectedStatus === chave;

          return (
            <div
              key={chave}
              onClick={() => !isTotalCard && onStatusSelect && onStatusSelect(chave)}
              style={{
                ...estiloCardPadrao,
                cursor: isTotalCard ? "default" : "pointer",
                border: isActive ? "2px solid #3182ce" : "2px solid transparent",
                backgroundColor: isActive ? "#ebf8ff" : "#f5f5f5",
                transform: isActive ? "scale(1.03)" : "scale(1)",
                transition: "all 0.15s ease",
              }}
            >
              <div style={estiloLabel}>{chave}</div>
              <div style={{ ...estiloValor, color: isActive ? "#2b6cb0" : "#2d3748" }}>{valor}</div>
              {isActive && (
                <div style={{ fontSize: "9px", color: "#3182ce", marginTop: 2 }}>✕ remover filtro</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const CardConclusaoMaster = ({ valor, detalhes }) => {
  const [aberto, setAberto] = React.useState(false);

  return (
    <div
      onClick={() => setAberto(!aberto)}
      style={{
        backgroundColor: "#f5f5f5",
        padding: "8px",
        borderRadius: "6px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        cursor: "pointer",
        border: aberto ? "1px solid #3182ce" : "1px solid transparent",
        transition: "all 0.3s ease",
        height: "fit-content"
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <div style={{ fontWeight: "bold", fontSize: "12px", color: "#4a5568" }}>Unidades Concluídas</div>
          <div style={{ fontSize: "18px", fontWeight: "bold" }}>{valor}</div>
        </div>
        <div style={{ fontSize: "10px", color: "#888" }}>{aberto ? "▲" : "▼"}</div>
      </div>

      {aberto && (
        <div style={{ marginTop: "12px", animation: "fadeIn 0.3s" }}>
          <div style={estiloLinha}>
            <span style={{ color: "#2f855a" }}>Registros Emitidos:</span>
            <strong>{detalhes.emitidos}</strong>
          </div>

          <div style={{ margin: "8px 0", borderTop: "1px dashed #ddd" }} />

          <div style={estiloLinha}>
            <span style={{ color: "#3d3535" }}>CRDU:</span>
            <span>{detalhes.crdu}</span>
          </div>

          <div style={estiloLinha}>
            <span>Casa Fechada:</span>
            <span>{detalhes.casaFechada}</span>
          </div>

          <div style={estiloLinha}>
            <span>Coleta Recusada:</span>
            <span>{detalhes.coletaRecusada}</span>
          </div>

          <div style={estiloLinha}>
            <span style={{ color: "#3d3535" }}>Em Andamento:</span>
            <span style={{ color: "#3d3535" }}>{Math.abs(detalhes.emAndamento)}</span>
          </div>
        </div>
      )}
    </div>
  );
};

const estiloLinha = { display: "flex", justifyContent: "space-between", fontSize: "13px", padding: "3px 0", color: "#2d3748" };
const estiloCardPadrao = { backgroundColor: "#f5f5f5", padding: "8px", borderRadius: "6px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", minHeight: "50px" };
const estiloLabel = { fontWeight: "bold", fontSize: "12px", color: "#4a5568", lineHeight: "1.2", marginBottom: "4px" };
const estiloValor = { fontSize: "18px", fontWeight: "bold", color: "#2d3748" };

export default NucleoInfoCards;
